(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["etk-lightbox"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.etkLightboxInit) return;
    window.etkLightboxInit = true;

    var index = 0;
    var lastFocus = null;

    function rootNode() {
      var nodes = document.querySelectorAll('[data-etk-lightbox]');
      if (!nodes.length) return null;
      for (var i = 1; i < nodes.length; i++) nodes[i].remove();
      return nodes[0];
    }

    function triggers() {
      return Array.prototype.slice.call(document.querySelectorAll('[data-etk-zoom]'));
    }

    function show(root, nextIndex) {
      var items = triggers();
      if (!items.length) return;
      var count = items.length;
      index = (nextIndex + count) % count;
      var trigger = items[index];
      var image = root.querySelector('.etk-lightbox__image');
      var caption = root.querySelector('.etk-lightbox__caption');
      image.src = trigger.getAttribute('data-full');
      image.alt = trigger.getAttribute('data-alt') || '';
      var text = trigger.getAttribute('data-caption') || '';
      caption.textContent = text;
      caption.hidden = text === '';
      var hideNav = count < 2;
      root.querySelector('[data-etk-lightbox-prev]').hidden = hideNav;
      root.querySelector('[data-etk-lightbox-next]').hidden = hideNav;
    }

    function openAt(start) {
      var root = rootNode();
      if (!root) return;
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('etk-lightbox-open');
      show(root, start);
      var closeButton = root.querySelector('.etk-lightbox__close');
      if (closeButton) closeButton.focus();
    }

    function close() {
      var root = rootNode();
      if (!root || root.hidden) return;
      root.hidden = true;
      document.documentElement.classList.remove('etk-lightbox-open');
      var image = root.querySelector('.etk-lightbox__image');
      if (image) image.removeAttribute('src');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-etk-zoom]');
      if (trigger) {
        event.preventDefault();
        var items = triggers();
        openAt(items.indexOf(trigger));
        return;
      }

      if (event.target.closest('[data-etk-lightbox-close]')) {
        event.preventDefault();
        close();
        return;
      }

      if (event.target.closest('[data-etk-lightbox-prev]')) {
        event.preventDefault();
        var rootPrev = rootNode();
        if (rootPrev && !rootPrev.hidden) show(rootPrev, index - 1);
        return;
      }

      if (event.target.closest('[data-etk-lightbox-next]')) {
        event.preventDefault();
        var rootNext = rootNode();
        if (rootNext && !rootNext.hidden) show(rootNext, index + 1);
      }
    });

    document.addEventListener('keydown', function (event) {
      var root = rootNode();
      if (!root || root.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(root, index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(root, index + 1);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
